var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpeaker = function SvgIconSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 24.85 8.5 20.1H5.75v-7.7H8.5l5.75-4.75zm-5-11.15h-2V19H9.1l3.65 3V10.85zM18.5 12.9c1.85 1.85 1.85 4.75 0 6.6l-.55.55L16.9 19l.55-.55a3.11 3.11 0 0 0 0-4.45l-.55-.55 1.05-1.05.55.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 10.8c3 3 3 7.9 0 10.95l-.55.55-1.05-1.05.55-.55c2.4-2.4 2.4-6.35 0-8.75l-.55-.55 1.05-1.05.55.55Z"
  })));
};
export default SvgIconSpeaker;